// extracted by mini-css-extract-plugin
export default {"imagebg":"mariposa_imagebg__nC64+"};